/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { ReplaceUploadFile200ResponseDto } from '../models';
// @ts-ignore
import type { UpdateDataRequestFileTypeDto } from '../models';
// @ts-ignore
import type { UploadStatusDto } from '../models';
// @ts-ignore
import type { UploadsPageDtoDto } from '../models';
/**
 * RestUploadsApi - axios parameter creator
 * @export
 */
export const RestUploadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all uploads
         * @param {UpdateDataRequestFileTypeDto} [uploadType] 
         * @param {UploadStatusDto} [status] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUploads: async (uploadType?: UpdateDataRequestFileTypeDto, status?: UploadStatusDto, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/uploads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (uploadType !== undefined) {
                localVarQueryParameter['uploadType'] = uploadType;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace the file for an existing upload and restart the processing. This can be used to fix validation errors or replace incorrect data. The upload will be reset and processing will start from the beginning. 
         * @summary Replace file for an existing upload
         * @param {string} uploadId Upload ID to replace file for
         * @param {File} file New file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUploadFile: async (uploadId: string, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadId' is not null or undefined
            assertParamExists('replaceUploadFile', 'uploadId', uploadId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('replaceUploadFile', 'file', file)
            const localVarPath = `/api/v2/uploads/{uploadId}/file`
                .replace(`{${"uploadId"}}`, encodeURIComponent(String(uploadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestUploadsApi - functional programming interface
 * @export
 */
export const RestUploadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestUploadsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all uploads
         * @param {UpdateDataRequestFileTypeDto} [uploadType] 
         * @param {UploadStatusDto} [status] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUploads(uploadType?: UpdateDataRequestFileTypeDto, status?: UploadStatusDto, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadsPageDtoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUploads(uploadType, status, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUploadsApi.listUploads']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Replace the file for an existing upload and restart the processing. This can be used to fix validation errors or replace incorrect data. The upload will be reset and processing will start from the beginning. 
         * @summary Replace file for an existing upload
         * @param {string} uploadId Upload ID to replace file for
         * @param {File} file New file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceUploadFile(uploadId: string, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReplaceUploadFile200ResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceUploadFile(uploadId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestUploadsApi.replaceUploadFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestUploadsApi - factory interface
 * @export
 */
export const RestUploadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestUploadsApiFp(configuration)
    return {
        /**
         * 
         * @summary List all uploads
         * @param {UpdateDataRequestFileTypeDto} [uploadType] 
         * @param {UploadStatusDto} [status] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUploads(uploadType?: UpdateDataRequestFileTypeDto, status?: UploadStatusDto, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<UploadsPageDtoDto> {
            return localVarFp.listUploads(uploadType, status, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace the file for an existing upload and restart the processing. This can be used to fix validation errors or replace incorrect data. The upload will be reset and processing will start from the beginning. 
         * @summary Replace file for an existing upload
         * @param {string} uploadId Upload ID to replace file for
         * @param {File} file New file to upload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceUploadFile(uploadId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<ReplaceUploadFile200ResponseDto> {
            return localVarFp.replaceUploadFile(uploadId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestUploadsApi - interface
 * @export
 * @interface RestUploadsApi
 */
export interface RestUploadsApiInterface {
    /**
     * 
     * @summary List all uploads
     * @param {UpdateDataRequestFileTypeDto} [uploadType] 
     * @param {UploadStatusDto} [status] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUploadsApiInterface
     */
    listUploads(uploadType?: UpdateDataRequestFileTypeDto, status?: UploadStatusDto, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<UploadsPageDtoDto>;

    /**
     * Replace the file for an existing upload and restart the processing. This can be used to fix validation errors or replace incorrect data. The upload will be reset and processing will start from the beginning. 
     * @summary Replace file for an existing upload
     * @param {string} uploadId Upload ID to replace file for
     * @param {File} file New file to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUploadsApiInterface
     */
    replaceUploadFile(uploadId: string, file: File, options?: RawAxiosRequestConfig): AxiosPromise<ReplaceUploadFile200ResponseDto>;

}

/**
 * RestUploadsApi - object-oriented interface
 * @export
 * @class RestUploadsApi
 * @extends {BaseAPI}
 */
export class RestUploadsApi extends BaseAPI implements RestUploadsApiInterface {
    /**
     * 
     * @summary List all uploads
     * @param {UpdateDataRequestFileTypeDto} [uploadType] 
     * @param {UploadStatusDto} [status] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUploadsApi
     */
    public listUploads(uploadType?: UpdateDataRequestFileTypeDto, status?: UploadStatusDto, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return RestUploadsApiFp(this.configuration).listUploads(uploadType, status, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Replace the file for an existing upload and restart the processing. This can be used to fix validation errors or replace incorrect data. The upload will be reset and processing will start from the beginning. 
     * @summary Replace file for an existing upload
     * @param {string} uploadId Upload ID to replace file for
     * @param {File} file New file to upload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestUploadsApi
     */
    public replaceUploadFile(uploadId: string, file: File, options?: RawAxiosRequestConfig) {
        return RestUploadsApiFp(this.configuration).replaceUploadFile(uploadId, file, options).then((request) => request(this.axios, this.basePath));
    }
}

